import React from 'react';
export function SocialProofStats() {
  return <section className="w-full bg-brand-violet py-6 px-4" data-id="element-285">
      <div className="max-w-2xl mx-auto flex flex-row items-center justify-between divide-x divide-white/20" data-id="element-286">
        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-287">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-288">
            +1.500
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-289">
            MUJERES TODO EL PAÍS
          </span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-290">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-291">
            9
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-292">
            TOMOS Y BONUS
          </span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-293">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-294">
            4.9/5 ⭐
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-295">
            CALIFICACIÓN
          </span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-296">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-297">
            🇦🇷
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-298">
            TODO EL PAÍS
          </span>
        </div>
      </div>
    </section>;
}